const PageTitle = {
    set: (title) => {
        const siteSuffix = document.title.substring(document.title.indexOf(' -'));
        document.title = title + siteSuffix;
    },
};
export default PageTitle;
